module.exports = __webpack_public_path__ + "static/scale-model-of-dc-ghosts-in-alexandria-virginia-6ffdba7ecebb292a764a5e950c91bced.png";